// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__FD4kx","boxTitle":"Qualiphy_boxTitle__3N_pr","box":"Qualiphy_box__3R2Ea","toggleWrap":"Qualiphy_toggleWrap__4cYoP"};